var Handlebars = require("../lib/handlebars.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div "
    + ((stack1 = lookupProperty(helpers,"class").call(alias1,"bottom-bar",{"name":"class","hash":{},"data":data,})) != null ? stack1 : "")
    + "><div "
    + ((stack1 = lookupProperty(helpers,"class").call(alias1,"btn select",{"name":"class","hash":{},"data":data,})) != null ? stack1 : "")
    + "><span "
    + ((stack1 = lookupProperty(helpers,"class").call(alias1,"icon icon-select",{"name":"class","hash":{},"data":data,})) != null ? stack1 : "")
    + "></span></div><div "
    + ((stack1 = lookupProperty(helpers,"class").call(alias1,"btn refresh",{"name":"class","hash":{},"data":data,})) != null ? stack1 : "")
    + "><span "
    + ((stack1 = lookupProperty(helpers,"class").call(alias1,"icon icon-refresh",{"name":"class","hash":{},"data":data,})) != null ? stack1 : "")
    + "></span></div><div "
    + ((stack1 = lookupProperty(helpers,"class").call(alias1,"btn highlight",{"name":"class","hash":{},"data":data,})) != null ? stack1 : "")
    + "><span "
    + ((stack1 = lookupProperty(helpers,"class").call(alias1,"icon icon-eye",{"name":"class","hash":{},"data":data,})) != null ? stack1 : "")
    + "></span></div><div "
    + ((stack1 = lookupProperty(helpers,"class").call(alias1,"btn reset",{"name":"class","hash":{},"data":data,})) != null ? stack1 : "")
    + "><span "
    + ((stack1 = lookupProperty(helpers,"class").call(alias1,"icon icon-reset",{"name":"class","hash":{},"data":data,})) != null ? stack1 : "")
    + "></span></div></div>";
},"useData":true});